import { useState, useEffect } from 'react'
import {
  InteractorLocationProvince,
  InteractorLocationCity,
  InteractorLocationDistrict,
  InteractorLocationSubdistrict,
  InteractorLocationPostalCode,
} from '../../Main'

const InteractorAccountAddressForm = (
  province,
  city,
  district,
  ward,
  fieldName = {
    provinceFieldName: 'province',
    cityFieldName: 'city',
    districtFieldName: 'district',
    subdistrictFieldName: 'ward',
    postalCodeFieldName: 'postalCode',
  },
) => {
  const { listProvince } = InteractorLocationProvince()
  const { listCity } = InteractorLocationCity()
  const { listDistrict } = InteractorLocationDistrict()
  const { listSubdistrict } = InteractorLocationSubdistrict()
  const { listPostalcode } = InteractorLocationPostalCode()
  const [optionProvince, setOptionProvince] = useState([])
  const [optionCity, setOptionCity] = useState([])
  const [optionDistrict, setOptionDistrict] = useState([])
  const [optionSubdistrict, setOptionSubdistrict] = useState([])
  const [optionPostalCode, setOptionPostalCode] = useState([])
  const [loadingProvince, setLoadingProvince] = useState(false)
  const [loadingCity, setLoadingCity] = useState(false)
  const [loadingDistrict, setLoadingDistrict] = useState(false)
  const [loadingSubdistrict, setLoadingSubdistrict] = useState(false)
  const [loadingPostalCode, setLoadingPostalCode] = useState(false)

  useEffect(() => {
    setLoadingProvince(true)
    listProvince(setOptionProvince, setLoadingProvince)
  }, [listProvince])

  useEffect(() => {
    if (province) {
      listCity(
        setOptionCity,
        typeof province === 'string' ? province : province.uid,
        setLoadingCity,
      )
    }
  }, [listCity, province])

  useEffect(() => {
    if (city) {
      listDistrict(
        setOptionDistrict,
        typeof city === 'string' ? city : city.uid,
        setLoadingDistrict,
      )
    }
  }, [city, listDistrict])

  useEffect(() => {
    if (district) {
      listSubdistrict(
        setOptionSubdistrict,
        typeof district === 'string' ? district : district.uid,
        setLoadingSubdistrict,
      )
    }
  }, [district, listSubdistrict])

  useEffect(() => {
    if (ward) {
      listPostalcode(
        setOptionPostalCode,
        typeof ward === 'string' ? ward : ward.uid,
        setLoadingPostalCode,
      )
    }
  }, [listPostalcode, ward])

  const handleProvince = (newValue, callback) => {
    setLoadingCity(true)
    setOptionCity([])
    setOptionDistrict([])
    setOptionSubdistrict([])
    setOptionPostalCode([])
    callback(fieldName.cityFieldName, null)
    callback(fieldName.districtFieldName, null)
    callback(fieldName.subdistrictFieldName, null)
    callback(fieldName.postalCodeFieldName, null)
    if (newValue === null) {
      setLoadingCity(false)
    }
  }

  const handleCity = (newValue, callback) => {
    setLoadingDistrict(true)
    setOptionDistrict([])
    setOptionSubdistrict([])
    setOptionPostalCode([])
    callback(fieldName.districtFieldName, null)
    callback(fieldName.subdistrictFieldName, null)
    callback(fieldName.postalCodeFieldName, null)
    if (newValue === null) {
      setLoadingDistrict(false)
    }
  }

  const handleDistrict = (newValue, callback) => {
    setLoadingSubdistrict(true)
    setOptionSubdistrict([])
    setOptionPostalCode([])
    callback(fieldName.subdistrictFieldName, null)
    callback(fieldName.postalCodeFieldName, null)
    if (newValue === null) {
      setLoadingSubdistrict(false)
    }
  }

  const handleSubdistrict = (newValue, callback) => {
    setLoadingPostalCode(true)
    setOptionPostalCode([])
    callback(fieldName.postalCodeFieldName, null)
    if (newValue === null) {
      setLoadingPostalCode(false)
    }
  }

  const handleStoreProvince = (newValue, callback) => {
    setLoadingCity(true)
    setOptionCity([])
    setOptionDistrict([])
    setOptionSubdistrict([])
    setOptionPostalCode([])
    callback('storeCity', null)
    callback('storeDistrict', null)
    callback('storeWard', null)
    callback('storePostalCode', null)
    if (newValue === null) {
      setLoadingCity(false)
    } else {
      listCity(setOptionCity, newValue.uid, setLoadingCity)
    }
  }

  const handleStoreCity = (newValue, callback) => {
    setLoadingDistrict(true)
    setOptionDistrict([])
    setOptionSubdistrict([])
    setOptionPostalCode([])
    callback('storeDistrict', null)
    callback('storeWard', null)
    callback('storePostalCode', null)
    if (newValue === null) {
      setLoadingDistrict(false)
    } else {
      listDistrict(setOptionDistrict, newValue.uid, setLoadingDistrict)
    }
  }

  const handleStoreDistrict = (newValue, callback) => {
    setLoadingSubdistrict(true)
    setOptionSubdistrict([])
    setOptionPostalCode([])
    callback('storeWard', null)
    callback('storePostalCode', null)
    if (newValue === null) {
      setLoadingSubdistrict(false)
    } else {
      listSubdistrict(setOptionSubdistrict, newValue.uid, setLoadingSubdistrict)
    }
  }

  const handleStoreSubdistrict = (newValue, callback) => {
    setLoadingPostalCode(true)
    setOptionPostalCode([])
    callback('storePostalCode', null)
    if (newValue === null) {
      setLoadingPostalCode(false)
    } else {
      listPostalcode(setOptionPostalCode, newValue.uid, setLoadingPostalCode)
    }
  }

  const handlePostalcode = (newValue) => {}

  const handleProvinceUpdate = (callback) => {
    listProvince((data) => {
      setOptionProvince(data)
      callback(data)
    }, setLoadingProvince)
  }

  const handleCityUpdate = (province_uid, callback) => {
    listCity(
      (data) => {
        setOptionCity(data)
        callback(data)
      },
      province_uid,
      setLoadingCity,
    )
  }

  const handleDistrictUpdate = (city_uid, callback) => {
    listDistrict(
      (data) => {
        setOptionDistrict(data)
        callback(data)
      },
      city_uid,
      setLoadingDistrict,
    )
  }

  const handleSubdistrictUpdate = (district_uid, callback) => {
    listSubdistrict(
      (data) => {
        setOptionSubdistrict(data)
        callback(data)
      },
      district_uid,
      setLoadingSubdistrict,
    )
  }

  const handlePostalcodeUpdate = (subdistrict_uid, callback) => {
    listPostalcode(
      (data) => {
        setOptionPostalCode(data)
        callback(data)
      },
      subdistrict_uid,
      setLoadingPostalCode,
    )
  }

  return {
    optionProvince,
    optionCity,
    optionDistrict,
    optionSubdistrict,
    optionPostalCode,
    setOptionProvince,
    setOptionCity,
    setOptionDistrict,
    setOptionSubdistrict,
    setOptionPostalCode,
    handleProvince,
    handleCity,
    handleDistrict,
    handleSubdistrict,
    handlePostalcode,
    handleStoreProvince,
    handleStoreCity,
    handleStoreDistrict,
    handleStoreSubdistrict,
    loadingProvince,
    loadingCity,
    loadingDistrict,
    loadingSubdistrict,
    loadingPostalCode,
    handleProvinceUpdate,
    handleCityUpdate,
    handleDistrictUpdate,
    handleSubdistrictUpdate,
    handlePostalcodeUpdate,
  }
}

export default InteractorAccountAddressForm
